import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getTargetActuals = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.targetActual.targetActual.entries, filter);
};
